import ConversationComposer from '@intercom/embercom-composer/components/conversation-composer';
export default ConversationComposer;
